<template >
        <v-card flat tile class="" >
          <v-toolbar flat >
            <v-toolbar-title>{{postTitle||title}}</v-toolbar-title>
          </v-toolbar>
          <v-container fluid grid-list-lg v-if="false" >
            <v-layout row wrap >
              <v-flex justify-center text-xs-center>
                <div>
                    <v-date-picker 
                      full-width 
                      flat 
                      v-model="date"
                      min="2016-06-15"
                      max="2018-03-20"
                      :allowed-dates="allowedDates"
                    ></v-date-picker>
                </div>   
              </v-flex>            
            </v-layout>
            <v-layout row wrap >
              <v-flex xs4 text-xs-center>
               <v-icon color="primary">lens</v-icon>Complete
              </v-flex>
              <v-flex xs4 text-xs-center>
                  <v-icon color="grey darken-2">lens</v-icon>Skipped
              </v-flex>
              <v-flex xs4 text-xs-center>
                  <v-icon  color="grey lighten-1 ">lens</v-icon>Abandoned
              </v-flex>
            </v-layout>
            <v-layout row wrap mb-2 mt-4>
              <v-flex xs8 text-xs-left>Current Streak</v-flex>
              <v-flex xs4 text-xs-right>3</v-flex>
            </v-layout>    
            <v-layout row wrap mb-2>
              <v-flex xs8 text-xs-left>Longest Streak</v-flex>
              <v-flex xs4 text-xs-right>4</v-flex>
            </v-layout>  
            <v-layout row wrap mb-2>
              <v-flex xs8 text-xs-left>Total Completions</v-flex>
              <v-flex xs4 text-xs-right>13</v-flex>
            </v-layout>                     
          </v-container>          
        </v-card> 
</template>

<script>

var mydate = new Date();
var resultdate = "" + mydate.getFullYear() +'-'+ ((mydate.getMonth() + 1) > 9 ? '' : '0') + (mydate.getMonth() + 1) +'-'+ (mydate.getDate() > 9 ? '' : '0') + mydate.getDate();
var calendarTime = resultdate;

export default {
  data () {
    return {
      title: 'Daily App Usage',
      date: calendarTime,
    }
  },
  methods: {
        allowedDates: val => parseInt(val.split('-')[2], 10) % 2 === 0
  },
  props: [ 
    'postTitle',
    'postFeelings',
  ]
  
}
</script>




// WEBPACK FOOTER //
// src/components/stats/CalendarStats.vue